var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15234 9.40234C9.46875 9.08594 9.99609 9.08594 10.3125 9.40234L11.9648 11.0898L13.6523 9.40234C13.9688 9.08594 14.4961 9.08594 14.8125 9.40234C15.1641 9.75391 15.1641 10.2812 14.8125 10.5977L13.1602 12.25L14.8125 13.9023C15.1641 14.2539 15.1641 14.7812 14.8125 15.0977C14.4961 15.4492 13.9688 15.4492 13.6523 15.0977L11.9648 13.4453L10.3125 15.0977C9.99609 15.4492 9.46875 15.4492 9.15234 15.0977C8.80078 14.7812 8.80078 14.2539 9.15234 13.9023L10.8047 12.25L9.15234 10.5977C8.80078 10.2812 8.80078 9.75391 9.15234 9.40234ZM21 12.25C21 17.2422 16.957 21.25 12 21.25C7.00781 21.25 3 17.2422 3 12.25C3 7.29297 7.00781 3.25 12 3.25C16.957 3.25 21 7.29297 21 12.25ZM12 4.9375C7.95703 4.9375 4.6875 8.24219 4.6875 12.25C4.6875 16.293 7.95703 19.5625 12 19.5625C16.0078 19.5625 19.3125 16.293 19.3125 12.25C19.3125 8.24219 16.0078 4.9375 12 4.9375Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/XCircle.e7b3ce3b83ba151f2241f3eb6450278c.svg";
export { ForwardRef as ReactComponent };